export const TextEditorBold = () => (
  <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M10.7822 7.17333C11.52 6.65778 12 5.89333 12 5.11111C12 3.39556 10.6044 2 8.88889 2H4V12.6667H9.55556C11.1467 12.6667 12.4444 11.3689 12.4444 9.77778C12.4444 8.62222 11.76 7.63556 10.7822 7.17333V7.17333ZM6.22222 3.77778H8.66667C9.40444 3.77778 10 4.37333 10 5.11111C10 5.84889 9.40444 6.44444 8.66667 6.44444H6.22222V3.77778ZM9.11111 10.8889H6.22222V8.22222H9.11111C9.84889 8.22222 10.4444 8.81778 10.4444 9.55556C10.4444 10.2933 9.84889 10.8889 9.11111 10.8889Z'
      fill='#334155'
    />
  </svg>
);
